export const CHECKBOX_FIELD_NAMES = {
    IS_USPS: 'IsUsps',
    IS_EMAIL_RECIPIENT: 'IsEmailRecipient',
    IS_TIN_CHECK: 'IsTinCheck',
    IS_STATE_FILLING: 'IsStateFilling',
    IS_TIN_MATCH: 'IsTinMatch',
    IS_PAYER: "IsPayer",
}
